import {
	AppLoaderEnd,
	AppLoaderStart,
	ParkingLoader,
	useConfigUIV1
} from '@gimlite/ui-v1'
import { createRoot } from 'react-dom/client'
import { CustomRouter } from './CustomRouter'
import config from './config'

const { ENV, VERSION_FRONT, BFF_HOST, BFF_WS_HOST } = config

const defaultTheme = 'dark'
const color = {
	dark: '#5dbed2',
	light: '#0a2652'
}

const App = () => {
	const {
		ConfigDialog,
		ConfigGQL,
		ConfigI18N,
		ConfigMaps,
		ConfigNotification,
		ConfigSSO,
		ConfigWizard,
		ConfigAnt,
		ConfigApp,
		ConfigMenu,
		ConfigTheme,
		ConfigRoot
	} = useConfigUIV1()

	return (
		<ConfigRoot>
			<AppLoaderStart
				config={{ item: ParkingLoader(), type: 'loader', defaultTheme, color }}
			>
				<ConfigApp
					debug={false}
					favicon={
						'https://cellar-c2.services.clever-cloud.com/yoonite-resources/default/iem.svg'
					}
					version={{
						env: config?.ENV,
						front: VERSION_FRONT
					}}
				>
					<ConfigGQL
						uri={BFF_HOST}
						headers={{
							'x-access-token': config.BFF_TOKEN
						}}
					>
						<ConfigSSO
							mode={{ type: 'children', parentUrl: config.SSO_PARENT_URL }}
							instance={{
								url: config.SSO_URL!,
								realm: config.SSO_REALM!,
								clientId: config.SSO_CLIENT_ID!
							}}
						>
							<ConfigI18N>
								<ConfigDialog>
									<ConfigWizard registry={[]}>
										<ConfigMenu>
											<ConfigNotification>
												<ConfigTheme color={color} defaultTheme={defaultTheme}>
													<ConfigAnt>
														<AppLoaderEnd>
															<CustomRouter />
														</AppLoaderEnd>
													</ConfigAnt>
												</ConfigTheme>
											</ConfigNotification>
										</ConfigMenu>
									</ConfigWizard>
								</ConfigDialog>
							</ConfigI18N>
						</ConfigSSO>
					</ConfigGQL>
				</ConfigApp>
			</AppLoaderStart>
		</ConfigRoot>
	)
}

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(<App />)
